<template>
<div class="ti">
  <div>
    <el-button size="mini" type="primary text2"  @click="modals(0)">全部</el-button>
    <el-button size="mini" type="primary text2" class="cdj_margin"  @click="modals(1)">待受理</el-button>
    <el-button size="mini" type="primary text2" class="cdj_margin"  @click="modals(2)">处理中</el-button>
    <el-button size="mini" type="primary text2" class="cdj_margin"  @click="modals(3)">待回访</el-button>
    <el-button size="mini" type="primary text2" class="cdj_margin"  @click="modals(4)">待评价</el-button>
    <el-button size="mini" type="primary text2" class="cdj_margin"  @click="modals(5)">已评价</el-button>
    <el-button size="mini" type="primary text2" class="cdj_margin"  @click="modals(6)">暂挂</el-button>
    <!-- <el-button type="primary text2"  @click="modals(2)">无效工单</el-button> -->
    <br><br>

    <el-date-picker
      v-model="value3"
      type="daterange"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
    <el-select size="mini" v-model="value" filterable placeholder="请选择组织" class="kuan" v-if="userJid[0]['id']==101020101">
      <el-option
        key=""
        label="全部"
        value="">
      </el-option>
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.company_name"
        :value="item.id">
      </el-option>
    </el-select>

    <el-select size="mini" v-model="value2" filterable placeholder="搜索选择" class="kuan">
      <el-option
        v-for="item in options1"
        :key="item.id"
        :label="item.label"
        :value="item.id">
      </el-option>
    </el-select>

    <el-input size="mini" class="search" placeholder="请输入姓名搜索" v-model="search" clearable></el-input>
    <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
    <el-button size="mini" class="cdj_margin" type="success text2" @click="orderExcel" v-if="userJid[1]['id']==101020102">导出</el-button>
  </div>
  <v-divider></v-divider>
  <v-simple-table :height="__TABLE_HEIGHT__">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">ID</th>
            <th class="text-left">编号</th>
            <th class="text-left">项目</th>
            <th class="text-left">姓名</th>
            <th class="text-left">电话</th>
            <th class="text-left">位置</th>
            <th class="text-left">类型</th>
            <th class="text-left">预警</th>
            <th class="text-left">状态</th>
            <th class="text-left">提交时间</th>
            <th class="text-left">操作</th>
          </tr>
        </thead>
        <tbody
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
          <tr class="text1" v-for="item in desserts" :key="item.id">
            <td >{{item.id}}</td>
            <td >{{item.numbar}}</td>
            <!-- <td >{{item.company_name}}</td> -->
            <td >{{item.pindex_id}}</td>
            <td >{{item.name}}</td>
            <td >{{item.phoen}}</td>
            <td >
                {{item.address}}
            </td>
            <td >
              <span v-if="item.typa == 9">咨询</span>
              <span v-if="item.typa == 10">建议</span>
              <span v-if="item.typa == 11">其它</span>
            </td>
            <td >{{item.warning}}</td>
            <td >
              <span v-if="item.state==1">待受理</span>
              <span v-if="item.state==2">处理中</span>
              <span v-if="item.state==3">待回访</span>
              <span v-if="item.state==4">待评价</span>
              <span v-if="item.state==5">已完成</span>
              <span v-if="item.state==6">暂挂中</span>
            </td>
            <td >{{item.date}}</td>
            <td class="cdj_td">
              <div style="color: #1867c0;cursor: pointer;" @click="chakan(item)">详情</div>
              <div v-if="userJid[2]['id']==101020103">
                <div style="color: red;margin-left: 5px;cursor: pointer;" @click="del( item.id )">删除</div>
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider></v-divider>
    <div class="pages" v-if="desserts">
      <Page :total="total" :page-size="page" @on-change="change"  show-total />
    </div>
    <div class="zhanwu" v-else>没有数据</div>
     <Modal
       v-model="modal12"
        ok-text="确定"
        width="500"
        title="查看详情">
        <div v-if="chakana['id']">
           <p>ID：{{chakana['id']}}</p>
           <p>编号：{{chakana['numbar']}}</p>
           <p>项目：{{chakana['pindex_id']}}</p>
           <p>姓名：{{chakana['name']}}</p>
           <p>电话：{{chakana['phoen']}}</p>
           <p>位置：{{chakana['address']}}</p>
           <p>类型：
              <span v-if="chakana.typa == 9">咨询</span>
              <span v-if="chakana.typa == 10">建议</span>
              <span v-if="chakana.typa == 11">其它</span>
           </p>
           <p>预警：{{chakana.warning}}</p>
           <p>状态：
              <span v-if="chakana.state==1">待受理</span>
              <span v-if="chakana.state==2">处理中</span>
              <span v-if="chakana.state==3">待回访</span>
              <span v-if="chakana.state==4">待评价</span>
              <span v-if="chakana.state==5">已完成</span>
              <span v-if="chakana.state==6">暂挂中</span>
           </p>
           <p>提交内容：{{chakana.content}}</p>
           <p>提交图片：</p>
           <p>
             <span v-for="item in chakana.content_img" :key="item">
                <el-image
                  style="width: 100px; height: 100px;margin-left:3px"
                  :src="imgurl+''+item"
                  :preview-src-list="srcList">
                </el-image>
             </span>
           </p>
           <p>提交时间：{{chakana.date}}</p>
           <span v-if="chakana.state >= 2">
             <p>受理时间：{{chakana.buter_start_date}}</p>
           </span>
           <span v-if="chakana.state > 2">
              <p>处理内容：{{chakana.butler_content}}</p>
              <p>处理图片：</p>
              <p>
                <span v-for="item in chakana.butler_content_img" :key="item">
                  <el-image
                    style="width: 100px; height: 100px;margin-left:3px"
                    :src="imgurl+''+item"
                    :preview-src-list="srcList1">
                  </el-image>
                </span>
              </p>
              <p>处理时间：{{chakana.butler_end_date}}</p>
           </span>
           <span v-if="chakana.state > 3">
             <p>回访时间：{{chakana.buter_visit_date}}</p>
           </span>
        </div>
     </Modal>
</div>

</template>

<script>
import imgurl from "../../../../assets/js/imgurl.js"
export default {
  name: 'Consult',
  data () {
    return {
      imgurl:'',
      srcList: [],
      srcList1:[],
      value3:[],
      modal12:false,
      loading:false,
       options: [
        {
          value: '',
          label: ''
        },],
       options1: [
        {
          id: 0,
          label: '选择类型'
        },
        {
          id: 9,
          label: '咨询'
        },
        {
          id: 10,
          label: '建议'
        },
        {
          id: 11,
          label: '其它'
        },
        ],
      value: '',
      value1:'',
      value2:0,
      input1: '',
      desserts: '',
      cs:'',
      total:0,
      page:12,
      search:'',
      anxiu:'保存',
      chakana:[],
      state:0,
      userJid:[],
      sdate:"",
      enddate:"",
    }
  },
  //界面没出来前加载
  created() {
    // this.userJid = [{id:''},{id:''},{id:''}];
    // this.$myhttp.get('admin/lavel3?pid=1010201',{
    //   'Content-Type': 'application/json'
    //   }).then(backdata=>{ // 异步执行成功后
    //     // console.log(backdata.data);
    //     if(backdata.data != 1){
    //       var date = backdata.data;
    //       date.forEach(item => {
    //         //本界面权限
    //         if(item.id == 101020101){
    //           this.userJid[0]['id'] = item.id;
    //         }
    //         if(item.id == 101020102){
    //           this.userJid[1]['id'] = item.id;
    //         }
    //         if(item.id == 101020103){
    //           this.userJid[2]['id'] = item.id;
    //         }
    //       });
    //     }else{
    //       //本界面权限
    //       this.userJid = [{id:'101020101'},{id:'101020102'},{id:'101020103'}];
    //     }
    //     // console.log(this.userJid)
    //   });
    this.userJid = [{id:'101020101'},{id:'101020102'},{id:'101020103'}];
  },
  // 加载数据
  mounted(){
    var t = Date.parse(new Date()) / 1000;//时间戳
    var login = window.localStorage.getItem('login');
    ERP.showLoading()
    this.$Loading.start();
    this.$myhttp.get('admin/getorderList?login='+login,{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        // this.value1 = backdata.data[0];//开启不查全部
        this.value = backdata.data;
        this.$myhttp.get('admin/Consult/index?id=1'+'&company='+this.value +'&company1='+this.value2+'&t='+t+"&distinguish=0",{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.desserts = backdata.data[0];
            this.total = backdata.data[1];
            this.page = backdata.data[2];
            this.$Loading.finish();
          ERP.hideLoading()
        });
    });
    //加载公司列表和归属列表
    this.$myhttp.get('admin/getcompany',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.options = backdata.data[0];
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //弹窗查看
    chakan(e){
      this.imgurl = imgurl;
      this.chakana = e;
      var img = e.content_img;
      var imgs = [];
      if(img.length>0){
        e.content_img.forEach(it=>{
          imgs.push(this.imgurl+it)
        })
        this.srcList= imgs
      }
      var imgs1 = [];
      if(e.state > 2){
        e.butler_content_img.forEach(it=>{
          imgs1.push(this.imgurl+it)
        })
        this.srcList1= imgs1
      }
      this.modal12 = true;
    },
    modals(e){
      if(this.state != e){
        this.$Loading.start();
        if(e == 0){
          this.state = "";
        }else{
          this.state = e;
        }
        this.$Loading.start();
        if(this.value3 != null){
          var d = this.value3[0];//开始时间
          var e = this.value3[1];//结束时间
          this.sdate = new Date(d).getTime()/1000;
          this.enddate = new Date(e).getTime()/1000;
        }else{
          this.sdate = "";
          this.enddate = "";
        }
        this.$myhttp.get('admin/Consult/index?id=1'+'&search='+ this.search +'&company='+this.value +'&company1='+this.value2+"&state="+this.state+"&sdate="+this.sdate+"&enddate="+this.enddate,{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.desserts = backdata.data[0];
            this.total = backdata.data[1];
            this.page = backdata.data[2];
            this.$Loading.finish();
        });
      }
    },
    //获得当前多少页,分页
    change(e){
      ERP.showLoading()
      this.$Loading.start();
      this.$myhttp.get('admin/Consult/index?id='+ e + '&search='+ this.search +'&company='+this.value +'&company1='+this.value2+"&state="+this.state+"&sdate="+this.sdate+"&enddate="+this.enddate,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
        ERP.hideLoading()
      });
    },
    //搜索
    searchs(){
      this.$Loading.start();
      if(this.value3 != null){
        var d = this.value3[0];//开始时间
        var e = this.value3[1];//结束时间
        this.sdate = new Date(d).getTime()/1000;
        this.enddate = new Date(e).getTime()/1000;
      }else{
        this.sdate = "";
        this.enddate = "";
      }
      this.$myhttp.get('admin/Consult/index?search='+ this.search + '&id=1'+'&company='+this.value +'&company1='+this.value2+"&state="+this.state+"&sdate="+this.sdate+"&enddate="+this.enddate,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
      });
    },
    //删除
    del(e){
      this.$confirm('确定删除吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading=true;
          this.$myhttp.post('admin/Consult/complaintDelete',{id:e},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data == 200){
                this.dela = true;
                var t = Date.parse(new Date()) / 1000;//时间戳
                this.$myhttp.get('admin/Consult/complaint?id=1'+'&company='+this.value +'&company1='+this.value2+"&state="+this.state,{
                  'Content-Type': 'application/json'
                  }).then(backdata=>{ // 异步执行成功后
                    this.desserts = backdata.data[0];
                    this.total = backdata.data[1];
                    this.page = backdata.data[2];
                    this.loading=false;
                    this.$Message.success('删除成功!');
                });
              }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    //导出
    orderExcel(){
      console.log(imgurl)
      if(this.value3 != null){
        var d = this.value3[0];//开始时间
        var e = this.value3[1];//结束时间
        this.sdate = new Date(d).getTime()/1000;
        this.enddate = new Date(e).getTime()/1000;
      }else{
        this.sdate = "";
        this.enddate = "";
      }
      var login = window.localStorage.getItem('login');
      var token = window.localStorage.getItem('token');
      this.$Message.success('导出中...');
      window.location.href = imgurl+'/admin/Consult/complaintExcel?search='+ this.search + '&id=1'+'&company='+this.value +'&company1='+this.value2+"&state="+this.state+"&sdate="+this.sdate+"&enddate="+this.enddate+"&login_name="+login+"&token="+token;
    }
  },

}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin{
  margin-left:1px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Consult/Consult.vue